<template>
    <!--Free Popup-->
    <div class="custom-model-main">
       <div class="custom-model-inner">
          <div class="close-btn">×</div>
          <div class="custom-model-wrap">
             <div class="pop-up-content-wrap">
                <h4>{{ $t("Search Form") }}</h4>
                <form action="/search" method="get" >
                   <input
                        type="search"
                        name="query"
                        :placeholder="$t('Search...')"
                        v-model="query"
                    />
                   <button type="submit" class="cmn--btn">
                    <span>{{ $t("Search") }}</span>
                </button>
                </form>
             </div>
          </div>
       </div>
       <div class="bg-overlay"></div>
    </div>
    <!--Free Popup-->
 </template>
 
 <script>
import { useSearchStore } from '@/store/search';
import { mapState } from "pinia";

 export default {
   name: "FreePopup",
   computed: {
    ...mapState(useSearchStore, ["query"]),
  },
 };
 </script>